
/** action types for network closets */
export const ADD_NETWORK_CLOSET = 'ADD_NETWORK_CLOSET'
export const DELETE_NETWORK_CLOSET = 'DELETE_NETWORK_CLOSET'

/** action types for generic wired devices */
export const ADD_WIRED_DEVICE = 'ADD_WIRED_DEVICE'
export const DELETE_WIRED_DEVICE = 'DELETE_WIRED_DEVICE'
export const CHANGE_WIRED_DEVICE_TYPE = 'CHANGE_WIRED_DEVICE_TYPE'
export const DUPLICATE_WIRED_DEVICE = 'DUPLICATE_WIRED_DEVICE'

/** action types for wires */
export const ADD_WIRE = 'ADD_WIRE'
export const DELETE_WIRE = 'DELETE_WIRE'
export const REMOVE_DEVICE_WIRES = 'REMOVE_DEVICE_WIRES'
export const ADD_WIRE_TOOLTIP_MAP_REFERENCE = 'ADD_WIRE_TOOLTIP_MAP_REFERENCE'

/** action types for access control */
export const ADD_DOOR_CONTROLLER = 'ADD_DOOR_CONTROLLER'
export const ADD_DOOR = 'ADD_DOOR'
export const ADD_PERIPHERAL = 'ADD_PERIPHERAL'
export const ADD_EXPANSION_CONTROLLER = 'ADD_EXPANSION_CONTROLLER'
export const DESTROY_DOOR_CONTROLLER = 'DESTROY_DOOR_CONTROLLER'
export const DELETE_DOOR_CONTROLLER = 'DELETE_DOOR_CONTROLLER'
export const DELETE_DOOR = 'DELETE_DOOR'
export const DELETE_PERIPHERAL = 'DELETE_PERIPHERAL'
export const CHANGE_MAIN_CONTROLLER_MODEL = 'CHANGE_MAIN_CONTROLLER_MODEL'
export const CHANGE_DOOR_CONTROLLER_MODEL = 'CHANGE_DOOR_CONTROLLER_MODEL'

/** shared update action */
export const UPDATE_ENTITY = 'UPDATE_ENTITY'



// WEBPACK FOOTER //
// ./src/actions/entityActionTypes.js